<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-row>
        <el-col :span="4">
          <el-form-item label="速记码">
            <el-autocomplete
              v-model="zhxx.shortCode"
              :trigger-on-focus="false"
              placeholder="请至少输入3个字符"
              :debounce="1000"
              :fetch-suggestions="queryShortCode"
              @select="selectShortCode"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="房产">
            <el-input
              placeholder="请选择房产"
              v-model="zhxx.roomName"
              readonly
              @focus="showRoomSelect = true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="收费时间" prop="dateRange">
            <el-date-picker
              v-model="query.dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-form-item label="费用种类" prop="feeSortId">
            <el-select v-model="query.feeSort" placeholder="请选择" style="width: 100%;" clearable>
              <el-option
                style="padding-left: 10px;"
                v-for="item in feeSortList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="缴费人">
            <el-input
              size="small"
              placeholder="请输入缴费人"
              clearable
              v-model="query.payManName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="支付方式" prop="payType">
            <el-select v-model="query.payType" placeholder="请选择" style="width: 100%;" clearable>
              <el-option
                style="padding-left: 10px;"
                v-for="item in payTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="票据号">
            <el-input size="small" placeholder="请输入票据号" clearable v-model="query.invoiceNo" />
          </el-form-item>
        </el-col>
        <el-col :span="4" style="margin-left: 20px;">
          <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
          <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      title="选择房产"
      :visible.sync="showRoomSelect"
      width="30%"
      top="16vh"
      custom-class="room-select-dialog"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      center
      @close="showRoomSelect = false"
    >
      <RoomSelect @select="selectRoom"></RoomSelect>
      <span slot="footer">
        <el-button @click="showRoomSelect = false">取消</el-button>
        <el-button type="primary" @click="confirmRoom">确定</el-button>
      </span>
    </el-dialog>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-download" @click="downloadData"
          >导出
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" icon="el-icon-plus" @click="backReturn(scope.row)"
          >还原
        </el-button>
        <el-button type="text" size="small" icon="el-icon-view" @click="backInvoke(scope.row)"
          >调用
        </el-button>
        <el-button type="text" size="small" icon="el-icon-check" @click="backUpdate(scope.row)"
          >更新
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getList,
  backReturn,
  backInvoke,
  backUpdate,
  getAreaList,
  queryPropertyFullName,
} from '@/api/v4ward/payback/handle';
import { mapGetters } from 'vuex';
import { getDictionary } from '../../../api/common';
import { loadZhxx } from '@/api/charge';
import RoomSelect from '@/components/room-select';
export default {
  components: { RoomSelect },
  data() {
    return {
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        menuWidth: 240,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        selection: true,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        //addBtn: false,
        align: 'center',
        column: [
          {
            label: '小区名称',
            prop: 'objectName',
          },
          {
            label: '地址',
            prop: 'roomName',
          },
          {
            label: '退款申请人',
            prop: 'payManName',
          },
          {
            label: '退费单号',
            prop: 'returnbillNo',
          },
          {
            label: '退费时间',
            prop: 'returnTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },
          {
            label: '退费金额',
            prop: 'returnAmount',
          },
          /*          {
            label: '调用时间',
            prop: 'invokeTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },*/
          {
            label: '状态',
            prop: 'returnStatus',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=return_apply',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '调用结果',
            prop: 'invokeResult',
          },
          {
            label: '退费渠道',
            prop: 'returnChannel',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=return_channel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '支付方式',
            prop: 'payType',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '退款人',
            prop: 'auditEmp',
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
          },
        ],
      },
      data: [],
      feeSortList: [],
      payTypeList: [],
      showRoomSelect: false,
      zhxx: {
        shortCode: '',
      },
      temp: {},
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feepay_back_return, false),
        viewBtn: this.vaildData(this.permission.feepay_back_invoke, false),
        delBtn: this.vaildData(this.permission.feepay_back_update, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {},
  mounted() {
    this.initSelectList();
  },
  methods: {
    //查询速记码
    queryShortCode(qs, cb) {
      if (qs.length < 3) {
        cb();
        return;
      }
      loadZhxx({ shortCode: qs }).then(({ data }) => {
        if (this.vdui.isEmpty(data)) {
          cb();
          this.$message.info('未查询到住户信息');
        } else if (data.length === 1) {
          this.zhxx = data[0];
          cb([]);
        } else {
          this._.forEach(data, (item) => {
            item.value = item.shortCode;
          });
          cb(data);
        }
      });
    },
    //选择速记码
    selectShortCode(item) {
      this.queryZhxx({ shortCode: item.shortCode });
    },
    //查询住户信息
    queryZhxx(params) {
      console.log('------查询住户信息------');
      loadZhxx(params).then(({ data }) => {
        console.log('---------' + JSON.stringify(data));
        this.zhxx = data[0];
        this.query.propertyId = this.zhxx.roomId;
      });
    },
    //选择房产
    selectRoom(item) {
      this.temp.roomId = item.roomId;
    },
    //确认选定房产
    confirmRoom() {
      this.showRoomSelect = false;
      if (this.temp.roomId) {
        this.zhxx.roomId = this.temp.roomId;
        this.queryZhxx({ roomId: this.zhxx.roomId });
      }
    },
    ////////////////

    downloadData() {
      console.log('导出数据.....');
    },
    initSelectList() {
      getDictionary('fee_sort').then((data) => {
        this.feeSortList = data.data;
      });
      getDictionary('pay_type').then((data) => {
        this.payTypeList = data.data;
      });
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchReset() {
      this.query = {};
      this.zhxx = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },

    onLoad(page, params = {}) {
      this.loading = true;
      if (params.dateRange) {
        params.dateFrom = params.dateRange[0] + ' 00:00:00.000';
        params.dateTo = params.dateRange[1] + ' 23:59:59.999';
        // /delete params.dateRange;
      }
      page = page || this.page;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  line-height: 25px;
  padding-left: 10px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-property-dialog-div {
  height: 500px;
  overflow: auto;
}
</style>
